import accountReducer from './account-reducer'

export default accountReducer
